<template>
  <div class="cusHeader"  v-loading="loading" style="height:calc(90vh - 140px);overflow: auto;">
    <div class="headerList" >
      <div class="headerList-title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-diandeng"></use>
        </svg>
        <p>要显示信息项（拖拽信息项目进行排序）</p>
      </div>
      <div class="headerList-box">
        <draggable
          class="list-group"
          :list="headerList"
          group="tableHeader"
          @change="add"
        >
          <div class="header-item" v-for="(element,index) in headerList"  :key="element.id">
            {{element.itemNameCh}}<svg class="icon" aria-hidden="true" @click="deleteList(index,element)" style="font-size: 12px">
            <use xlink:href="#icon-shanchu"></use>
          </svg>
          </div>
        </draggable>
      </div>
    </div>
    <div class="headersList">
      <div class="headerList-title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-diandeng"></use>
        </svg>
        <p>全部信息项（拖拽或点击信息项目到上面区域）</p>
      </div>
      <div class="headersDatas">
        <div class="headersData" v-for="(item,index) in headerData"  :key="item.id">
          <div class="headersData-title">
            <p>{{item.title}}</p>
            <div class="fold" @click="fold(index)">
              <svg v-if="item.fold" class="icon" aria-hidden="true">
                <use xlink:href="#icon-shangjiantou"></use>
              </svg>
              <svg v-if="!item.fold" class="icon" aria-hidden="true">
                <use xlink:href="#icon-xiajiantou"></use>
              </svg>
            </div>
          </div>
          <draggable v-show="item.fold"
                     class="headersData-box"
                     :list="item.data"
                     :group="{ name: 'tableHeader', pull: 'clone', put: false}"
                     draggable = ".draggable"
                     :sort="false"
          >

            <div class="headersData-list" v-for="header in item.data" :key="header.field"
                 :class="header.undraggable?'undraggable':'draggable'"
                 @click="header.undraggable?deleteList(-1,header):add({'added':{'element':header}},true)"
            >
              {{header.itemNameCh}}
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  // import {getCustomTableHeader  } from  "@/api/common/common"
  import {getAverageWageColumnsList  } from  "@/api/report/report"
  export default {
    props: {
      infoSetId: {
        type: String,
        default: ''
      },
      modelType: {
        type: String,
        default: ''
      },
      headerList:{
        type:Array,
        default: () => (
          []
        )
      },
      headerData:{
        type:Array,
        default: () => (
          []
        )
      }
    },
    data(){
      return{
        headerParam:{
          infoSetId:'',
          modelType:'',
        },
        frist:true
      }
    },
    components: {
      draggable,
    },
    created(){
      // 加载数据
      console.log(this.headerList);
      console.log('lalalal')
      console.log(this.headerData);
      this._getInfoItem();

    },
    mounted(){



    },
    methods:{
      _getInfoItem(){
        debugger;
        for(var i = 0; i < this.headerData.length; i++){
          this.$set(this.headerData[i],"fold",true)
          for (let j in this.headerData[i].data) {
            let data = this.headerData[i].data[j];
            for (let k in this.headerList) {
              let temp = this.headerList[k];
              if(temp.field == data.field){
                this.headerData[i].data[j]['undraggable'] = true;
                break;
              }
            }
          }
        }
        this.$emit('update:headerList', this.headerList);//更新父的表头信息列
/*
					for (var i = 0; i < this.headerData.length; i++) {
						for (var index = 0; index < this.headerList.length; index++) {
									if(this.headerData[i].id === this.headerList[index].id){
										this.$set(this.headerData[i],'undraggable',true)
									}
								}
					}
*/
      },
      fold(inx){
        this.$set(this.headerData[inx],'fold',!this.headerData[inx].fold)
      },
      // add:function(e){
      //   if(e.added){
      //     const id = e.added.element.id;
      //     for (var i = 0; i < this.headerData.length; i++) {
      //           if(this.headerData[i].id === id){
      //
      //             this.$set(this.headerData[i],'undraggable',true)
      //           }
      //     }
      //     this.$emit('update:headerList', this.headerList);
      //   }
      //   console.log(this.headerList)
      // },
      add:function(e,t){
        if(e.added){
          const id = e.added.element.id;
          const parentId = e.added.element.setId;
          const index = e.added.newIndex;
          console.log(id,parentId)
          for (var i = 0; i < this.headerData.length; i++) {
            // if(this.headerData[i].id === parentId){
              for(var j = 0; j < this.headerData[i].data.length; j++){
                if(this.headerData[i].data[j].id === id){
                  this.$set(this.headerData[i].data[j],'undraggable',true)
                }
              }
            // }
          }
          if(t){//点击时 触发
            this.headerList.push(e.added.element)//点击 追加
          }else{
            this.headerList.splice(index,1,e.added.element)//拖拽 插入
          }
          this.$emit('update:headerList', this.headerList);
        }
        console.log(this.headerList)
      },
      deleteList(inx,item){
        debugger;
        if(inx == -1){
          //下方点击删除 需要找到在上方列表的序号
          for (let i in this.headerList) {

            let temp = this.headerList[i];
            if(temp.field == item.field){
              inx = i;
              break;
            }
          }
        }else{
          //上方点击删除时
          // 当值是10010001 时 为固定项不能删除
          const isFixed = this.headerList[inx].isFixed;
          if('10010001'==isFixed){
            this.$message.error('固定项不能删除');
            return ;
          }
        }
        console.log('=============',item)
        const parentId = this.headerList[inx].setId;
        const field = this.headerList[inx].field;

        for (var i = 0; i < this.headerData.length; i++) {
          // if(this.headerData[i].id === parentId){
            for(var j = 0; j < this.headerData[i].data.length; j++){
              if(this.headerData[i].data[j].field === field){
                this.$set(this.headerData[i].data[j],'undraggable',false)
                this.headerList.splice(inx, 1);
              }
            }
          // }
        }

        this.$emit('update:headerList', this.headerList);
      }
    }
  };
</script>
<style>
	.el-dialog{
		margin-top: 10vh!important;
		margin-bottom: 0;
	}
</style>
<style scoped>

  .headerList{
    border-bottom:1px solid #cccccc;
    padding-bottom: 20px;
  }
.headerList-title{
  color:#FFC000;
  font-size: 16px;
  display: flex;
  line-height: 40px;
  align-items: center;
  padding-left: 20px;
}
.headerList-title p{
  color:#999999;
  font-size: 14px;
  margin-left: 6px;
}
  .headerList-box{
    background-color: #FFFBE6;
    padding:20px 20px 10px 20px;
  }
.headerList-box .list-group{
  display: flex;
  flex-wrap: wrap;
}
  .headerList-box .list-group div{
    height: 30px;
    border:1px solid #ffc000;
    background-color: #fff;
    padding:0 10px;
    line-height: 30px;
    border-radius: 2px;
    color:#000000;
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: move;
  }
.headerList-box div div svg{
  margin-left: 10px;
  color:#ff9600;
  cursor: pointer;
}
  .headersData-title{
    background-color: #F4F4F4;
    border-radius: 2px;
    padding-left: 20px;
    color:#999999;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px
  }
  .fold{
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }
  .headersData-box{
    display: flex;
    padding:20px 20px 10px 20px;
    flex-wrap: wrap;
  }
  .headersData-list{
    background-color: #f4f4f4;
    font-size: 14px;
    color:#000000;
    line-height: 30px;
    padding: 0 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: move;
  }
  .headersData{
    margin-bottom: 10px;
  }
  .undraggable{
    background-color: #FFA729;
    color:#ffffff;
  }
</style>
